import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = { class: "admin-add-btn" }
const _hoisted_15 = {
  class: "add-btn-admin",
  id: "addBlogCategoryLink",
  href: "/authority/blog-category"
}
const _hoisted_16 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_17 = { class: "tags" }
const _hoisted_18 = { class: "delete-all-btn-link" }
const _hoisted_19 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_20 = { class: "add-banner-image-section" }
const _hoisted_21 = { class: "add-banner-image-box" }
const _hoisted_22 = { class: "admin-input-field" }
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = { class: "admin-input-field" }
const _hoisted_25 = { class: "slug-input-wrapper" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = { class: "admin-input-field" }
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_31 = { class: "admin-input-field" }
const _hoisted_32 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_33 = { class: "admin-input-field" }
const _hoisted_34 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_35 = { class: "admin-input-field" }
const _hoisted_36 = { class: "admin-date-input" }
const _hoisted_37 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_38 = { class: "admin-input-field" }
const _hoisted_39 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_40 = { class: "admin-input-field" }
const _hoisted_41 = { class: "image-upload-input upload-banner-image" }
const _hoisted_42 = { class: "file-input-box" }
const _hoisted_43 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_44 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_45 = ["src"]
const _hoisted_46 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_47 = { class: "admin-input-field-submit" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_50 = { class: "admin-item-list-section-scroll" }
const _hoisted_51 = { class: "admin-item-list-top" }
const _hoisted_52 = { class: "admin-item-list-row" }
const _hoisted_53 = { class: "admin-item-checkbox" }
const _hoisted_54 = { class: "admin-checkbox-input" }
const _hoisted_55 = ["checked"]
const _hoisted_56 = { class: "admin-item-image" }
const _hoisted_57 = { class: "admin-item-actions" }
const _hoisted_58 = { class: "admin-item-list-btm" }
const _hoisted_59 = { ref: "sortableList" }
const _hoisted_60 = { class: "admin-item-box-top" }
const _hoisted_61 = { class: "admin-item-list-row" }
const _hoisted_62 = { class: "admin-item-checkbox" }
const _hoisted_63 = { class: "admin-checkbox-input" }
const _hoisted_64 = ["id", "onChange", "checked"]
const _hoisted_65 = ["for"]
const _hoisted_66 = { class: "admin-item-image" }
const _hoisted_67 = { class: "sm-img" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "admin-item-blogs-title text-limit" }
const _hoisted_70 = { class: "admin-item-blogs-category text-limit" }
const _hoisted_71 = { class: "admin-item-blogs-author text-limit" }
const _hoisted_72 = { class: "admin-item-blogs-location text-limit" }
const _hoisted_73 = { class: "admin-item-blogs-desc text-limit" }
const _hoisted_74 = { class: "admin-item-blogs-date" }
const _hoisted_75 = ["title"]
const _hoisted_76 = { class: "admin-item-actions" }
const _hoisted_77 = { class: "admin-action-link" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_83 = { class: "add-banner-image-section" }
const _hoisted_84 = { class: "add-banner-image-box" }
const _hoisted_85 = { class: "admin-input-field" }
const _hoisted_86 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_87 = { class: "admin-input-field" }
const _hoisted_88 = { class: "slug-input-wrapper" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_91 = { class: "admin-input-field" }
const _hoisted_92 = ["value"]
const _hoisted_93 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_94 = { class: "admin-input-field" }
const _hoisted_95 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_96 = { class: "admin-input-field" }
const _hoisted_97 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_98 = { class: "admin-input-field" }
const _hoisted_99 = { class: "admin-date-input" }
const _hoisted_100 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_101 = { class: "admin-input-field" }
const _hoisted_102 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_103 = { class: "admin-input-field" }
const _hoisted_104 = { class: "image-upload-input upload-banner-image" }
const _hoisted_105 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_106 = { class: "file-input-box" }
const _hoisted_107 = { class: "image-upload-input-item-uploaded" }
const _hoisted_108 = ["src"]
const _hoisted_109 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_110 = { class: "admin-input-field-submit" }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = { class: "admin-pagination-section" }
const _hoisted_113 = { class: "custom-row" }
const _hoisted_114 = { class: "item-show-selectbox" }
const _hoisted_115 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_116 = ["onClick"]
const _hoisted_117 = { key: 2 }
const _hoisted_118 = { class: "admin-site-footer" }
const _hoisted_119 = { class: "container" }
const _hoisted_120 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_121 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_122 = { class: "modal-content" }
const _hoisted_123 = { class: "confirmation-popup-mid" }
const _hoisted_124 = { class: "confirmation-popup-btm" }
const _hoisted_125 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_BLOGS_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachBlogInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchBlogs(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addBlogBtn",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openAddBlogForm && _ctx.openAddBlogForm(...args)))
                      }, [
                        _cache[46] || (_cache[46] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_BLOG_BUTTON), 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", _hoisted_15, [
                        _cache[47] || (_cache[47] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_BLOG_CATEGORY_BUTTON), 1)
                      ])
                    ])
                  ]),
                  (_ctx.selectedBlogs.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedBlogs.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedBlogs = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_BLOG_TEXT), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("form", {
                        id: "addBlogForm",
                        onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.JOB_BLOG_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "blogTitleInput",
                            type: "text",
                            placeholder: "Enter the Title",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newBlog.title) = $event)),
                            onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateNewBlogSlug && _ctx.updateNewBlogSlug(...args)))
                          }, null, 544), [
                            [_vModelText, _ctx.newBlog.title]
                          ]),
                          (!_ctx.newBlog.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[48] || (_cache[48] = _createElementVNode("label", null, " URL Slug ", -1)),
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              id: "blogSlugInput",
                              type: "text",
                              placeholder: "Enter the URL Slug",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newBlog.slug) = $event)),
                              disabled: !_ctx.isNewSlugEditable
                            }, null, 8, _hoisted_26), [
                              [_vModelText, _ctx.newBlog.slug]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "edit-slug-btn",
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleNewSlugEdit && _ctx.toggleNewSlugEdit(...args)))
                            }, _toDisplayString(_ctx.isNewSlugEditable ? 'Save' : 'Edit'), 1)
                          ]),
                          (!_ctx.newBlog.slug)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BLOG_CATEGORY_LABEL), 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "admin-selectbox",
                            id: "blogCategorySelectBox",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newBlog.blogCategory) = $event))
                          }, [
                            _cache[49] || (_cache[49] = _createElementVNode("option", { value: "" }, "Select the blog category", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogCategories, (category) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: category.id,
                                value: category.title
                              }, _toDisplayString(category.title), 9, _hoisted_29))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.newBlog.blogCategory]
                          ]),
                          (!_ctx.newBlog.blogCategory)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.AUTHOR_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "authorInput",
                            type: "text",
                            placeholder: "Enter the Author",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newBlog.author) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newBlog.author]
                          ]),
                          (!_ctx.newBlog.author)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.LOCATION_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "locationInput",
                            placeholder: "Enter the location",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newBlog.location) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newBlog.location]
                          ]),
                          (!_ctx.newBlog.location)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DATE_LABEL), 1),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_datepicker, {
                              modelValue: _ctx.newBlog.blogPostDate,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newBlog.blogPostDate) = $event)),
                              id: "dateInput",
                              class: "date-icon",
                              placeholder: "Enter Date"
                            }, null, 8, ["modelValue"])
                          ]),
                          (!_ctx.newBlog.blogPostDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BLOG_DESCRIPTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Blog Description",
                            class: "text-editer",
                            id: "blogDescriptionInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newBlog.description,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newBlog.description) = $event)),
                            config: _ctx.Config
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newBlog.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                            }, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("button", {
                                  class: "image-upload-input-item-delete-btn",
                                  id: "uploaded-img-delete-btn",
                                  type: "button",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.clearUploadedImage(false)))
                                }),
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "addBlogFileInput",
                                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png"
                                }, null, 32)
                              ]),
                              (!_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_IMAGE_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createElementVNode("img", {
                                      src: _ctx.imageUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_45)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (!_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("button", {
                            class: "admin-btn-outline-primary add-new-cancel",
                            id: "submitBtn",
                            type: "submit",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_48),
                          _createElementVNode("button", {
                            class: "admin-btn-outline-secondary add-new-cancel",
                            id: "cancelBtn",
                            type: "button",
                            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editBlogsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section admin-blogs-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_55),
                              _cache[51] || (_cache[51] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-title",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-category",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleSort('blogCategory'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.BLOG_CATEGORY_LABEL) + " ", 1),
                            (_ctx.sortBy === 'blogCategory' || _ctx.sortBy === '-blogCategory')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-blogCategory' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-author",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleSort('author'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.AUTHOR_LABEL) + " ", 1),
                            (_ctx.sortBy === 'author' || _ctx.sortBy === '-author')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-author' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-location",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toggleSort('location'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.LOCATION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'location' || _ctx.sortBy === '-location')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-location' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-desc",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.toggleSort('description'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.BLOG_DESCRIPTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'description' || _ctx.sortBy === '-description')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-description' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-blogs-date",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.toggleSort('blogPostDate'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DATE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'blogPostDate' || _ctx.sortBy === '-blogPostDate')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-blogPostDate' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1),
                          _cache[52] || (_cache[52] = _createElementVNode("div", { class: "clear" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editBlogsData, (blog, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: blog.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': blog.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + blog.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleBlogSelection(blog.slug)),
                                        checked: _ctx.selectedBlogs.includes(blog.slug)
                                      }, null, 40, _hoisted_64),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + blog.id
                                      }, null, 8, _hoisted_65)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(blog.blogImage, `w_31,h_31/`),
                                        alt: ""
                                      }, null, 8, _hoisted_68)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_69, _toDisplayString(blog.title), 1),
                                  _createElementVNode("div", _hoisted_70, _toDisplayString(blog.blogCategory), 1),
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(blog.author), 1),
                                  _createElementVNode("div", _hoisted_72, _toDisplayString(blog.location), 1),
                                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.useStripHtml(blog.description)), 1),
                                  _createElementVNode("div", _hoisted_74, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", {
                                      title: _ctx.formatDate(blog.blogPostDate),
                                      "data-bs-toggle": "tooltip"
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDate(blog.blogPostDate)), 1)
                                    ], 8, _hoisted_75)), [
                                      [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { right: true }
                                      ]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("ul", _hoisted_77, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "blogPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editBlog(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_78)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "blogPgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', blog.slug), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_79)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (blog.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "blogPgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeBlogStatus(blog.slug, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_80))
                                          : (blog.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "blogPgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeBlogStatus(blog.slug, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_81))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              (blog.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createElementVNode("div", _hoisted_83, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_BLOG_TEXT), 1),
                                      _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("div", _hoisted_85, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.JOB_BLOG_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "blogTitleInput",
                                            type: "text",
                                            placeholder: "Enter the Title",
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editBlogData.title) = $event)),
                                            onInput: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.updateEditBlogSlug && _ctx.updateEditBlogSlug(...args)))
                                          }, null, 544), [
                                            [_vModelText, _ctx.editBlogData.title]
                                          ]),
                                          (!_ctx.editBlogData.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_87, [
                                          _cache[53] || (_cache[53] = _createElementVNode("label", null, " URL Slug ", -1)),
                                          _createElementVNode("div", _hoisted_88, [
                                            _withDirectives(_createElementVNode("input", {
                                              id: "blogEditSlugInput",
                                              type: "text",
                                              placeholder: "Enter the URL Slug",
                                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editBlogData.slug) = $event)),
                                              disabled: !_ctx.isEditSlugEditable
                                            }, null, 8, _hoisted_89), [
                                              [_vModelText, _ctx.editBlogData.slug]
                                            ]),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "edit-slug-btn",
                                              onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.toggleEditSlugEdit && _ctx.toggleEditSlugEdit(...args)))
                                            }, _toDisplayString(_ctx.isEditSlugEditable ? 'Save' : 'Edit'), 1)
                                          ]),
                                          (!_ctx.editBlogData.slug)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_91, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BLOG_CATEGORY_LABEL), 1),
                                          _withDirectives(_createElementVNode("select", {
                                            class: "admin-selectbox",
                                            id: "blogCategorySelectBox",
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editBlogData.blogCategory) = $event))
                                          }, [
                                            _cache[54] || (_cache[54] = _createElementVNode("option", { value: "" }, "Select the blog category", -1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogCategories, (category) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: category.id,
                                                value: category.title
                                              }, _toDisplayString(category.title), 9, _hoisted_92))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, _ctx.editBlogData.blogCategory]
                                          ]),
                                          (!_ctx.editBlogData.blogCategory)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_94, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.AUTHOR_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "authorInput",
                                            type: "text",
                                            placeholder: "Enter the Author",
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.editBlogData.author) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editBlogData.author]
                                          ]),
                                          (!_ctx.editBlogData.author)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.LOCATION_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            id: "locationInput",
                                            placeholder: "Enter the location",
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editBlogData.location) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editBlogData.location]
                                          ]),
                                          (!_ctx.editBlogData.location)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_98, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DATE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_99, [
                                            _createVNode(_component_datepicker, {
                                              modelValue: _ctx.editBlogData.blogPostDate,
                                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editBlogData.blogPostDate) = $event)),
                                              id: "dateInput",
                                              class: "date-icon",
                                              placeholder: "Enter Date"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          (!_ctx.editBlogData.blogPostDate)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_101, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.BLOG_DESCRIPTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            id: "blogDescriptionInput",
                                            class: "text-editer",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editBlogData.description,
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editBlogData.description) = $event)),
                                            config: _ctx.Config
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editBlogData.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_103, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_104, [
                                            _createElementVNode("div", _hoisted_105, [
                                              _createElementVNode("div", _hoisted_106, [
                                                _createElementVNode("button", {
                                                  class: "image-upload-input-item-delete-btn",
                                                  id: "uploaded-img-delete-btn",
                                                  type: "button",
                                                  onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.clearUploadedImage(true)))
                                                }),
                                                _createElementVNode("input", {
                                                  type: "file",
                                                  id: "editBlogFileInput",
                                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_107, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_108)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.editimageSrc && !_ctx.selectedEditFile)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_110, [
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-primary",
                                            id: "submitBtn",
                                            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.submitEditForm())),
                                            disabled: _ctx.isSubmitting
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_111),
                                          _createElementVNode("button", {
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            id: "cancelBtn",
                                            onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[55] || (_cache[55] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[56] || (_cache[56] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_116))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[57] || (_cache[57] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_117, [...(_cache[58] || (_cache[58] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_118, [
      _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_120, [
      _createElementVNode("div", _hoisted_121, [
        _createElementVNode("div", _hoisted_122, [
          _cache[59] || (_cache[59] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("button", _hoisted_125, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}